module.exports = __webpack_public_path__ + "bc48d646bf569019fb6fb128188ac034.png";